var cov_23jhm5whfq = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tree/Node.tsx",
      hash = "c367580f5c28e84493b21f1400d2ac7c02a31d39",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tree/Node.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 11,
          column: 50
        }
      },
      "1": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 48
        }
      },
      "2": {
        start: {
          line: 13,
          column: 26
        },
        end: {
          line: 13,
          column: 55
        }
      },
      "3": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 14,
          column: 43
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "5": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 22
        }
      },
      "6": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 16
        }
      },
      "7": {
        start: {
          line: 40,
          column: 33
        },
        end: {
          line: 40,
          column: 81
        }
      },
      "8": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 54
        }
      },
      "9": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 50
        }
      },
      "10": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 52
        }
      },
      "11": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 58
        }
      },
      "12": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 56
        }
      },
      "13": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 54
        }
      },
      "14": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 50
        }
      },
      "15": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 40
        }
      },
      "16": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 32
        }
      },
      "17": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 40
        }
      },
      "18": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 31
        }
      },
      "19": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 66
        }
      },
      "20": {
        start: {
          line: 62,
          column: 35
        },
        end: {
          line: 62,
          column: 66
        }
      },
      "21": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 21
        }
      },
      "22": {
        start: {
          line: 70,
          column: 42
        },
        end: {
          line: 70,
          column: 52
        }
      },
      "23": {
        start: {
          line: 71,
          column: 25
        },
        end: {
          line: 71,
          column: 35
        }
      },
      "24": {
        start: {
          line: 72,
          column: 21
        },
        end: {
          line: 72,
          column: 65
        }
      },
      "25": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 53
        }
      },
      "26": {
        start: {
          line: 73,
          column: 41
        },
        end: {
          line: 73,
          column: 53
        }
      },
      "27": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 65
        }
      },
      "28": {
        start: {
          line: 74,
          column: 54
        },
        end: {
          line: 74,
          column: 65
        }
      },
      "29": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 43
        }
      },
      "30": {
        start: {
          line: 76,
          column: 31
        },
        end: {
          line: 76,
          column: 43
        }
      },
      "31": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 41
        }
      },
      "32": {
        start: {
          line: 77,
          column: 29
        },
        end: {
          line: 77,
          column: 41
        }
      },
      "33": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 15
        }
      },
      "34": {
        start: {
          line: 83,
          column: 29
        },
        end: {
          line: 83,
          column: 39
        }
      },
      "35": {
        start: {
          line: 85,
          column: 21
        },
        end: {
          line: 85,
          column: 41
        }
      },
      "36": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 31
        }
      },
      "37": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 40
        }
      },
      "38": {
        start: {
          line: 87,
          column: 18
        },
        end: {
          line: 87,
          column: 40
        }
      },
      "39": {
        start: {
          line: 91,
          column: 56
        },
        end: {
          line: 91,
          column: 66
        }
      },
      "40": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 26
        }
      },
      "41": {
        start: {
          line: 92,
          column: 20
        },
        end: {
          line: 92,
          column: 26
        }
      },
      "42": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 21
        }
      },
      "43": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 49
        }
      },
      "44": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 69
        }
      },
      "45": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 35
        }
      },
      "46": {
        start: {
          line: 98,
          column: 20
        },
        end: {
          line: 98,
          column: 68
        }
      },
      "47": {
        start: {
          line: 100,
          column: 22
        },
        end: {
          line: 100,
          column: 107
        }
      },
      "48": {
        start: {
          line: 101,
          column: 17
        },
        end: {
          line: 101,
          column: 50
        }
      },
      "49": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 64
        }
      },
      "50": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 45
        }
      },
      "51": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 46
        }
      },
      "52": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 40
        }
      },
      "53": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 41
        }
      },
      "54": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 50
        }
      },
      "55": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 44
        }
      },
      "56": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 67
        }
      },
      "57": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 116,
          column: 5
        }
      },
      "58": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 115,
          column: 8
        }
      },
      "59": {
        start: {
          line: 113,
          column: 25
        },
        end: {
          line: 113,
          column: 57
        }
      },
      "60": {
        start: {
          line: 114,
          column: 9
        },
        end: {
          line: 114,
          column: 82
        }
      },
      "61": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 104
        }
      },
      "62": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 122,
          column: 9
        }
      },
      "63": {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 121,
          column: 41
        }
      },
      "64": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 27
        }
      },
      "65": {
        start: {
          line: 126,
          column: 21
        },
        end: {
          line: 126,
          column: 27
        }
      },
      "66": {
        start: {
          line: 128,
          column: 52
        },
        end: {
          line: 128,
          column: 62
        }
      },
      "67": {
        start: {
          line: 129,
          column: 20
        },
        end: {
          line: 129,
          column: 35
        }
      },
      "68": {
        start: {
          line: 130,
          column: 20
        },
        end: {
          line: 130,
          column: 42
        }
      },
      "69": {
        start: {
          line: 131,
          column: 19
        },
        end: {
          line: 131,
          column: 47
        }
      },
      "70": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 35
        }
      },
      "71": {
        start: {
          line: 133,
          column: 29
        },
        end: {
          line: 133,
          column: 35
        }
      },
      "72": {
        start: {
          line: 134,
          column: 27
        },
        end: {
          line: 134,
          column: 49
        }
      },
      "73": {
        start: {
          line: 135,
          column: 26
        },
        end: {
          line: 135,
          column: 47
        }
      },
      "74": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 137,
          column: 63
        }
      },
      "75": {
        start: {
          line: 137,
          column: 57
        },
        end: {
          line: 137,
          column: 63
        }
      },
      "76": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 68
        }
      },
      "77": {
        start: {
          line: 139,
          column: 49
        },
        end: {
          line: 139,
          column: 68
        }
      },
      "78": {
        start: {
          line: 141,
          column: 18
        },
        end: {
          line: 141,
          column: 30
        }
      },
      "79": {
        start: {
          line: 142,
          column: 17
        },
        end: {
          line: 142,
          column: 46
        }
      },
      "80": {
        start: {
          line: 143,
          column: 25
        },
        end: {
          line: 143,
          column: 90
        }
      },
      "81": {
        start: {
          line: 144,
          column: 25
        },
        end: {
          line: 144,
          column: 53
        }
      },
      "82": {
        start: {
          line: 145,
          column: 25
        },
        end: {
          line: 145,
          column: 45
        }
      },
      "83": {
        start: {
          line: 147,
          column: 19
        },
        end: {
          line: 147,
          column: 35
        }
      },
      "84": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 42
        }
      },
      "85": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 163,
          column: 5
        }
      },
      "86": {
        start: {
          line: 150,
          column: 6
        },
        end: {
          line: 150,
          column: 57
        }
      },
      "87": {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 159,
          column: 7
        }
      },
      "88": {
        start: {
          line: 152,
          column: 8
        },
        end: {
          line: 158,
          column: 9
        }
      },
      "89": {
        start: {
          line: 153,
          column: 10
        },
        end: {
          line: 153,
          column: 23
        }
      },
      "90": {
        start: {
          line: 154,
          column: 10
        },
        end: {
          line: 154,
          column: 61
        }
      },
      "91": {
        start: {
          line: 156,
          column: 10
        },
        end: {
          line: 156,
          column: 23
        }
      },
      "92": {
        start: {
          line: 157,
          column: 10
        },
        end: {
          line: 157,
          column: 80
        }
      },
      "93": {
        start: {
          line: 161,
          column: 6
        },
        end: {
          line: 161,
          column: 19
        }
      },
      "94": {
        start: {
          line: 162,
          column: 6
        },
        end: {
          line: 162,
          column: 76
        }
      },
      "95": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 164,
          column: 36
        }
      },
      "96": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 166,
          column: 56
        }
      },
      "97": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 170,
          column: 35
        }
      },
      "98": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 171,
          column: 27
        }
      },
      "99": {
        start: {
          line: 171,
          column: 21
        },
        end: {
          line: 171,
          column: 27
        }
      },
      "100": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 22
        }
      },
      "101": {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 173,
          column: 40
        }
      },
      "102": {
        start: {
          line: 173,
          column: 34
        },
        end: {
          line: 173,
          column: 40
        }
      },
      "103": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 175,
          column: 106
        }
      },
      "104": {
        start: {
          line: 175,
          column: 53
        },
        end: {
          line: 175,
          column: 106
        }
      },
      "105": {
        start: {
          line: 176,
          column: 34
        },
        end: {
          line: 176,
          column: 44
        }
      },
      "106": {
        start: {
          line: 177,
          column: 21
        },
        end: {
          line: 177,
          column: 83
        }
      },
      "107": {
        start: {
          line: 178,
          column: 23
        },
        end: {
          line: 178,
          column: 32
        }
      },
      "108": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 180,
          column: 53
        }
      },
      "109": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 183,
          column: 5
        }
      },
      "110": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 34
        }
      },
      "111": {
        start: {
          line: 187,
          column: 91
        },
        end: {
          line: 187,
          column: 101
        }
      },
      "112": {
        start: {
          line: 189,
          column: 21
        },
        end: {
          line: 189,
          column: 71
        }
      },
      "113": {
        start: {
          line: 190,
          column: 24
        },
        end: {
          line: 190,
          column: 55
        }
      },
      "114": {
        start: {
          line: 191,
          column: 35
        },
        end: {
          line: 191,
          column: 45
        }
      },
      "115": {
        start: {
          line: 193,
          column: 22
        },
        end: {
          line: 202,
          column: 5
        }
      },
      "116": {
        start: {
          line: 204,
          column: 22
        },
        end: {
          line: 204,
          column: 24
        }
      },
      "117": {
        start: {
          line: 205,
          column: 4
        },
        end: {
          line: 211,
          column: 5
        }
      },
      "118": {
        start: {
          line: 206,
          column: 6
        },
        end: {
          line: 210,
          column: 8
        }
      },
      "119": {
        start: {
          line: 214,
          column: 24
        },
        end: {
          line: 214,
          column: 28
        }
      },
      "120": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 219,
          column: 5
        }
      },
      "121": {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 216,
          column: 31
        }
      },
      "122": {
        start: {
          line: 217,
          column: 11
        },
        end: {
          line: 219,
          column: 5
        }
      },
      "123": {
        start: {
          line: 218,
          column: 6
        },
        end: {
          line: 218,
          column: 37
        }
      },
      "124": {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 239,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 49
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 37
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 25
          },
          end: {
            line: 55,
            column: 3
          }
        },
        line: 52
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        },
        loc: {
          start: {
            line: 57,
            column: 33
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 57
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 3
          }
        },
        loc: {
          start: {
            line: 61,
            column: 47
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 61
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        loc: {
          start: {
            line: 65,
            column: 34
          },
          end: {
            line: 67,
            column: 3
          }
        },
        line: 65
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 69,
            column: 3
          }
        },
        loc: {
          start: {
            line: 69,
            column: 11
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 69
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 82,
            column: 3
          }
        },
        loc: {
          start: {
            line: 82,
            column: 17
          },
          end: {
            line: 88,
            column: 3
          }
        },
        line: 82
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 90,
            column: 3
          }
        },
        loc: {
          start: {
            line: 90,
            column: 42
          },
          end: {
            line: 123,
            column: 3
          }
        },
        line: 90
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 112,
            column: 42
          },
          end: {
            line: 112,
            column: 43
          }
        },
        loc: {
          start: {
            line: 112,
            column: 47
          },
          end: {
            line: 115,
            column: 7
          }
        },
        line: 112
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 120,
            column: 15
          },
          end: {
            line: 120,
            column: 16
          }
        },
        loc: {
          start: {
            line: 120,
            column: 21
          },
          end: {
            line: 122,
            column: 5
          }
        },
        line: 120
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 125,
            column: 3
          }
        },
        loc: {
          start: {
            line: 125,
            column: 53
          },
          end: {
            line: 167,
            column: 3
          }
        },
        line: 125
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 169,
            column: 2
          },
          end: {
            line: 169,
            column: 3
          }
        },
        loc: {
          start: {
            line: 169,
            column: 18
          },
          end: {
            line: 184,
            column: 3
          }
        },
        line: 169
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 186,
            column: 2
          },
          end: {
            line: 186,
            column: 3
          }
        },
        loc: {
          start: {
            line: 186,
            column: 11
          },
          end: {
            line: 240,
            column: 3
          }
        },
        line: 186
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 66
          }
        }, {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 62,
            column: 66
          }
        }],
        line: 62
      },
      "1": {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 53
          }
        }, {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 53
          }
        }],
        line: 73
      },
      "2": {
        loc: {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 16
          }
        }, {
          start: {
            line: 73,
            column: 20
          },
          end: {
            line: 73,
            column: 39
          }
        }],
        line: 73
      },
      "3": {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 65
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 65
          }
        }],
        line: 74
      },
      "4": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 31
          }
        }, {
          start: {
            line: 74,
            column: 35
          },
          end: {
            line: 74,
            column: 52
          }
        }],
        line: 74
      },
      "5": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 43
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 43
          }
        }],
        line: 76
      },
      "6": {
        loc: {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 76,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 76,
            column: 16
          }
        }, {
          start: {
            line: 76,
            column: 20
          },
          end: {
            line: 76,
            column: 29
          }
        }],
        line: 76
      },
      "7": {
        loc: {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 77,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 77,
            column: 41
          }
        }, {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 77,
            column: 41
          }
        }],
        line: 77
      },
      "8": {
        loc: {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 77,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 77,
            column: 14
          }
        }, {
          start: {
            line: 77,
            column: 18
          },
          end: {
            line: 77,
            column: 27
          }
        }],
        line: 77
      },
      "9": {
        loc: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 40
          }
        }, {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 40
          }
        }],
        line: 87
      },
      "10": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 26
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 26
          }
        }],
        line: 92
      },
      "11": {
        loc: {
          start: {
            line: 100,
            column: 22
          },
          end: {
            line: 100,
            column: 107
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 22
          },
          end: {
            line: 100,
            column: 29
          }
        }, {
          start: {
            line: 100,
            column: 34
          },
          end: {
            line: 100,
            column: 106
          }
        }],
        line: 100
      },
      "12": {
        loc: {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        }, {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 116,
            column: 5
          }
        }],
        line: 111
      },
      "13": {
        loc: {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 27
          }
        }, {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 27
          }
        }],
        line: 126
      },
      "14": {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 35
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 35
          }
        }],
        line: 133
      },
      "15": {
        loc: {
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 133,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 133,
            column: 16
          }
        }, {
          start: {
            line: 133,
            column: 20
          },
          end: {
            line: 133,
            column: 27
          }
        }],
        line: 133
      },
      "16": {
        loc: {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 137,
            column: 63
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 137,
            column: 63
          }
        }, {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 137,
            column: 63
          }
        }],
        line: 137
      },
      "17": {
        loc: {
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 137,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 137,
            column: 19
          }
        }, {
          start: {
            line: 137,
            column: 23
          },
          end: {
            line: 137,
            column: 55
          }
        }],
        line: 137
      },
      "18": {
        loc: {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 68
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 68
          }
        }, {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 139,
            column: 68
          }
        }],
        line: 139
      },
      "19": {
        loc: {
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 139,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 139,
            column: 23
          }
        }, {
          start: {
            line: 139,
            column: 27
          },
          end: {
            line: 139,
            column: 47
          }
        }],
        line: 139
      },
      "20": {
        loc: {
          start: {
            line: 143,
            column: 25
          },
          end: {
            line: 143,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 143,
            column: 25
          },
          end: {
            line: 143,
            column: 84
          }
        }, {
          start: {
            line: 143,
            column: 88
          },
          end: {
            line: 143,
            column: 90
          }
        }],
        line: 143
      },
      "21": {
        loc: {
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 163,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 163,
            column: 5
          }
        }, {
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 163,
            column: 5
          }
        }],
        line: 149
      },
      "22": {
        loc: {
          start: {
            line: 151,
            column: 6
          },
          end: {
            line: 159,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 151,
            column: 6
          },
          end: {
            line: 159,
            column: 7
          }
        }, {
          start: {
            line: 151,
            column: 6
          },
          end: {
            line: 159,
            column: 7
          }
        }],
        line: 151
      },
      "23": {
        loc: {
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        }, {
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        }],
        line: 152
      },
      "24": {
        loc: {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 171,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 171,
            column: 27
          }
        }, {
          start: {
            line: 171,
            column: 4
          },
          end: {
            line: 171,
            column: 27
          }
        }],
        line: 171
      },
      "25": {
        loc: {
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 173,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 173,
            column: 40
          }
        }, {
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 173,
            column: 40
          }
        }],
        line: 173
      },
      "26": {
        loc: {
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 175,
            column: 106
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 175,
            column: 106
          }
        }, {
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 175,
            column: 106
          }
        }],
        line: 175
      },
      "27": {
        loc: {
          start: {
            line: 175,
            column: 8
          },
          end: {
            line: 175,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 175,
            column: 8
          },
          end: {
            line: 175,
            column: 22
          }
        }, {
          start: {
            line: 175,
            column: 26
          },
          end: {
            line: 175,
            column: 51
          }
        }],
        line: 175
      },
      "28": {
        loc: {
          start: {
            line: 177,
            column: 30
          },
          end: {
            line: 177,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 177,
            column: 30
          },
          end: {
            line: 177,
            column: 72
          }
        }, {
          start: {
            line: 177,
            column: 76
          },
          end: {
            line: 177,
            column: 78
          }
        }],
        line: 177
      },
      "29": {
        loc: {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        }, {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        }],
        line: 181
      },
      "30": {
        loc: {
          start: {
            line: 181,
            column: 8
          },
          end: {
            line: 181,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 181,
            column: 8
          },
          end: {
            line: 181,
            column: 14
          }
        }, {
          start: {
            line: 181,
            column: 19
          },
          end: {
            line: 181,
            column: 32
          }
        }, {
          start: {
            line: 181,
            column: 36
          },
          end: {
            line: 181,
            column: 54
          }
        }],
        line: 181
      },
      "31": {
        loc: {
          start: {
            line: 190,
            column: 24
          },
          end: {
            line: 190,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 190,
            column: 24
          },
          end: {
            line: 190,
            column: 32
          }
        }, {
          start: {
            line: 190,
            column: 36
          },
          end: {
            line: 190,
            column: 55
          }
        }],
        line: 190
      },
      "32": {
        loc: {
          start: {
            line: 205,
            column: 4
          },
          end: {
            line: 211,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 205,
            column: 4
          },
          end: {
            line: 211,
            column: 5
          }
        }, {
          start: {
            line: 205,
            column: 4
          },
          end: {
            line: 211,
            column: 5
          }
        }],
        line: 205
      },
      "33": {
        loc: {
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 219,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 219,
            column: 5
          }
        }, {
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 219,
            column: 5
          }
        }],
        line: 215
      },
      "34": {
        loc: {
          start: {
            line: 217,
            column: 11
          },
          end: {
            line: 219,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 217,
            column: 11
          },
          end: {
            line: 219,
            column: 5
          }
        }, {
          start: {
            line: 217,
            column: 11
          },
          end: {
            line: 219,
            column: 5
          }
        }],
        line: 217
      },
      "35": {
        loc: {
          start: {
            line: 225,
            column: 68
          },
          end: {
            line: 225,
            column: 100
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 68
          },
          end: {
            line: 225,
            column: 81
          }
        }, {
          start: {
            line: 225,
            column: 85
          },
          end: {
            line: 225,
            column: 100
          }
        }],
        line: 225
      },
      "36": {
        loc: {
          start: {
            line: 237,
            column: 9
          },
          end: {
            line: 237,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 237,
            column: 9
          },
          end: {
            line: 237,
            column: 20
          }
        }, {
          start: {
            line: 237,
            column: 24
          },
          end: {
            line: 237,
            column: 63
          }
        }],
        line: 237
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tree/Node.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { createElement } from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { isFunc, isString } from '../utils/is';
import { treeClass } from './styles';
import Content from './Content';
import { getDirectionClass } from '../utils/classname';
var placeElement = (cov_23jhm5whfq.s[0]++, document.createElement('div'));
cov_23jhm5whfq.s[1]++;
placeElement.className = treeClass('drag-place');
var innerPlaceElement = (cov_23jhm5whfq.s[2]++, document.createElement('div'));
cov_23jhm5whfq.s[3]++;
placeElement.appendChild(innerPlaceElement);
var placeInfo = (cov_23jhm5whfq.s[4]++, {
  start: '',
  target: ''
});
var isDragging = (cov_23jhm5whfq.s[5]++, false);

var Node =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Node, _PureComponent);

  var _super = _createSuper2(Node);

  function Node(props) {
    var _this;

    _classCallCheck(this, Node);

    cov_23jhm5whfq.f[0]++;
    cov_23jhm5whfq.s[6]++;
    _this = _super.call(this, props);
    _this.element = void 0;
    _this.dragImage = void 0;

    var _ref = (cov_23jhm5whfq.s[7]++, props.bindNode(props.id, _this.update.bind(_assertThisInitialized(_this)))),
        active = _ref.active,
        expanded = _ref.expanded;

    cov_23jhm5whfq.s[8]++;
    _this.state = {
      active: active,
      expanded: expanded,
      fetching: false
    };
    cov_23jhm5whfq.s[9]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_23jhm5whfq.s[10]++;
    _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_this));
    cov_23jhm5whfq.s[11]++;
    _this.handleDragStart = _this.handleDragStart.bind(_assertThisInitialized(_this));
    cov_23jhm5whfq.s[12]++;
    _this.handleDragOver = _this.handleDragOver.bind(_assertThisInitialized(_this));
    cov_23jhm5whfq.s[13]++;
    _this.handleDragEnd = _this.handleDragEnd.bind(_assertThisInitialized(_this));
    cov_23jhm5whfq.s[14]++;
    _this.setFetching = _this.setFetching.bind(_assertThisInitialized(_this));
    cov_23jhm5whfq.s[15]++;
    _this.isLeaf = _this.isLeaf.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Node, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_23jhm5whfq.f[1]++;
      cov_23jhm5whfq.s[16]++;

      _get(_getPrototypeOf(Node.prototype), "componentWillUnmount", this).call(this);

      cov_23jhm5whfq.s[17]++;
      this.props.unbindNode(this.props.id);
    }
  }, {
    key: "setFetching",
    value: function setFetching(fetching) {
      cov_23jhm5whfq.f[2]++;
      cov_23jhm5whfq.s[18]++;
      this.setState({
        fetching: fetching
      });
    }
  }, {
    key: "update",
    value: function update(key, value) {
      cov_23jhm5whfq.f[3]++;
      cov_23jhm5whfq.s[19]++;

      if (this.state[key] !== value) {
        cov_23jhm5whfq.b[0][0]++;
        cov_23jhm5whfq.s[20]++;
        this.setState(_defineProperty({}, key, value));
      } else {
        cov_23jhm5whfq.b[0][1]++;
      }
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_23jhm5whfq.f[4]++;
      cov_23jhm5whfq.s[21]++;
      this.element = el;
    }
  }, {
    key: "isLeaf",
    value: function isLeaf() {
      cov_23jhm5whfq.f[5]++;

      var _ref2 = (cov_23jhm5whfq.s[22]++, this.props),
          childrenKey = _ref2.childrenKey,
          data = _ref2.data,
          loader = _ref2.loader;

      var _ref3 = (cov_23jhm5whfq.s[23]++, this.state),
          fetching = _ref3.fetching;

      var children = (cov_23jhm5whfq.s[24]++, data[childrenKey]);
      cov_23jhm5whfq.s[25]++;

      if ((cov_23jhm5whfq.b[2][0]++, children) && (cov_23jhm5whfq.b[2][1]++, children.length > 0)) {
        cov_23jhm5whfq.b[1][0]++;
        cov_23jhm5whfq.s[26]++;
        return false;
      } else {
        cov_23jhm5whfq.b[1][1]++;
      }

      cov_23jhm5whfq.s[27]++;

      if ((cov_23jhm5whfq.b[4][0]++, Array.isArray(children)) || (cov_23jhm5whfq.b[4][1]++, children === null)) {
        cov_23jhm5whfq.b[3][0]++;
        cov_23jhm5whfq.s[28]++;
        return true;
      } else {
        cov_23jhm5whfq.b[3][1]++;
      }

      cov_23jhm5whfq.s[29]++;

      if ((cov_23jhm5whfq.b[6][0]++, fetching) && (cov_23jhm5whfq.b[6][1]++, !children)) {
        cov_23jhm5whfq.b[5][0]++;
        cov_23jhm5whfq.s[30]++;
        return false;
      } else {
        cov_23jhm5whfq.b[5][1]++;
      }

      cov_23jhm5whfq.s[31]++;

      if ((cov_23jhm5whfq.b[8][0]++, loader) && (cov_23jhm5whfq.b[8][1]++, !fetching)) {
        cov_23jhm5whfq.b[7][0]++;
        cov_23jhm5whfq.s[32]++;
        return false;
      } else {
        cov_23jhm5whfq.b[7][1]++;
      }

      cov_23jhm5whfq.s[33]++;
      return true;
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      cov_23jhm5whfq.f[6]++;

      var _ref4 = (cov_23jhm5whfq.s[34]++, this.props),
          id = _ref4.id,
          onToggle = _ref4.onToggle; // eslint-disable-next-line


      var expanded = (cov_23jhm5whfq.s[35]++, !this.state.expanded);
      cov_23jhm5whfq.s[36]++;
      this.setState({
        expanded: expanded
      });
      cov_23jhm5whfq.s[37]++;

      if (onToggle) {
        cov_23jhm5whfq.b[9][0]++;
        cov_23jhm5whfq.s[38]++;
        onToggle(id, expanded);
      } else {
        cov_23jhm5whfq.b[9][1]++;
      }
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(event) {
      var _this2 = this;

      cov_23jhm5whfq.f[7]++;

      var _ref5 = (cov_23jhm5whfq.s[39]++, this.props),
          dragImageSelector = _ref5.dragImageSelector,
          dragImageStyle = _ref5.dragImageStyle,
          data = _ref5.data;

      cov_23jhm5whfq.s[40]++;

      if (isDragging) {
        cov_23jhm5whfq.b[10][0]++;
        cov_23jhm5whfq.s[41]++;
        return;
      } else {
        cov_23jhm5whfq.b[10][1]++;
      }

      cov_23jhm5whfq.s[42]++;
      isDragging = true;
      cov_23jhm5whfq.s[43]++;
      event.dataTransfer.effectAllowed = 'copyMove';
      cov_23jhm5whfq.s[44]++;
      event.dataTransfer.setData('text/plain', this.props.id);
      cov_23jhm5whfq.s[45]++;
      placeInfo.start = this.props.id;
      var element = (cov_23jhm5whfq.s[46]++, document.querySelector(dragImageSelector(data)));
      var dragImage = (cov_23jhm5whfq.s[47]++, (cov_23jhm5whfq.b[11][0]++, element) || (cov_23jhm5whfq.b[11][1]++, this.element.querySelector(".".concat(treeClass('content')))));
      var rect = (cov_23jhm5whfq.s[48]++, dragImage.getBoundingClientRect());
      cov_23jhm5whfq.s[49]++;
      this.dragImage = dragImage.cloneNode(true);
      cov_23jhm5whfq.s[50]++;
      document.body.appendChild(this.dragImage);
      cov_23jhm5whfq.s[51]++;
      this.dragImage.style.position = 'absolute';
      cov_23jhm5whfq.s[52]++;
      this.dragImage.style.top = '-1000px';
      cov_23jhm5whfq.s[53]++;
      this.dragImage.style.left = '-1000px';
      cov_23jhm5whfq.s[54]++;
      this.dragImage.style.width = "".concat(rect.width, "px");
      cov_23jhm5whfq.s[55]++;
      this.dragImage.style.background = '#fff';
      cov_23jhm5whfq.s[56]++;
      this.dragImage.style.boxShadow = '0 0 5px 0 rgba(0, 0, 0, 0.1)';
      cov_23jhm5whfq.s[57]++;

      if (dragImageStyle) {
        cov_23jhm5whfq.b[12][0]++;
        cov_23jhm5whfq.s[58]++;
        Object.keys(dragImageStyle).forEach(function (k) {
          cov_23jhm5whfq.f[8]++;
          var styleKey = (cov_23jhm5whfq.s[59]++, k);
          cov_23jhm5whfq.s[60]++;
          _this2.dragImage.style[styleKey] = dragImageStyle[styleKey];
        });
      } else {
        cov_23jhm5whfq.b[12][1]++;
      }

      cov_23jhm5whfq.s[61]++;
      event.dataTransfer.setDragImage(this.dragImage, event.clientX - rect.left, event.clientY - rect.top);
      cov_23jhm5whfq.s[62]++;
      setTimeout(function () {
        cov_23jhm5whfq.f[9]++;
        cov_23jhm5whfq.s[63]++;
        _this2.element.style.display = 'none';
      }, 0);
    }
  }, {
    key: "handleDragOver",
    value: function handleDragOver(e) {
      cov_23jhm5whfq.f[10]++;
      cov_23jhm5whfq.s[64]++;

      if (!isDragging) {
        cov_23jhm5whfq.b[13][0]++;
        cov_23jhm5whfq.s[65]++;
        return;
      } else {
        cov_23jhm5whfq.b[13][1]++;
      }

      var _ref6 = (cov_23jhm5whfq.s[66]++, this.props),
          dragHoverExpand = _ref6.dragHoverExpand,
          datum = _ref6.datum,
          dragSibling = _ref6.dragSibling;

      var startId = (cov_23jhm5whfq.s[67]++, placeInfo.start);
      var current = (cov_23jhm5whfq.s[68]++, datum.getPath(startId));
      var target = (cov_23jhm5whfq.s[69]++, datum.getPath(this.props.id));
      cov_23jhm5whfq.s[70]++;

      if ((cov_23jhm5whfq.b[15][0]++, !current) || (cov_23jhm5whfq.b[15][1]++, !target)) {
        cov_23jhm5whfq.b[14][0]++;
        cov_23jhm5whfq.s[71]++;
        return;
      } else {
        cov_23jhm5whfq.b[14][1]++;
      }

      var currentPathStr = (cov_23jhm5whfq.s[72]++, current.path.join('/'));
      var targetPathStr = (cov_23jhm5whfq.s[73]++, target.path.join('/'));
      cov_23jhm5whfq.s[74]++;

      if ((cov_23jhm5whfq.b[17][0]++, dragSibling) && (cov_23jhm5whfq.b[17][1]++, targetPathStr !== currentPathStr)) {
        cov_23jhm5whfq.b[16][0]++;
        cov_23jhm5whfq.s[75]++;
        return;
      } else {
        cov_23jhm5whfq.b[16][1]++;
      }

      cov_23jhm5whfq.s[76]++;

      if ((cov_23jhm5whfq.b[19][0]++, dragHoverExpand) && (cov_23jhm5whfq.b[19][1]++, !this.state.expanded)) {
        cov_23jhm5whfq.b[18][0]++;
        cov_23jhm5whfq.s[77]++;
        this.handleToggle();
      } else {
        cov_23jhm5whfq.b[18][1]++;
      }

      var hover = (cov_23jhm5whfq.s[78]++, this.element);
      var rect = (cov_23jhm5whfq.s[79]++, hover.getBoundingClientRect());
      var clientHeight = (cov_23jhm5whfq.s[80]++, (cov_23jhm5whfq.b[20][0]++, e.target.getBoundingClientRect().height) || (cov_23jhm5whfq.b[20][1]++, 20));
      var hoverMiddleY = (cov_23jhm5whfq.s[81]++, (rect.bottom - rect.top) / 2);
      var hoverClientY = (cov_23jhm5whfq.s[82]++, e.clientY - rect.top);
      var position = (cov_23jhm5whfq.s[83]++, this.props.index);
      cov_23jhm5whfq.s[84]++;
      innerPlaceElement.style.height = '0px';
      cov_23jhm5whfq.s[85]++;

      if (hoverClientY < hoverMiddleY + clientHeight * 0.2) {
        cov_23jhm5whfq.b[21][0]++;
        cov_23jhm5whfq.s[86]++;
        hover.parentNode.insertBefore(placeElement, hover);
        cov_23jhm5whfq.s[87]++;

        if (hoverClientY > clientHeight * 0.3) {
          cov_23jhm5whfq.b[22][0]++;
          cov_23jhm5whfq.s[88]++;

          if (!dragSibling) {
            cov_23jhm5whfq.b[23][0]++;
            cov_23jhm5whfq.s[89]++;
            position = -1;
            cov_23jhm5whfq.s[90]++;
            innerPlaceElement.style.height = "".concat(rect.height, "px");
          } else {
            cov_23jhm5whfq.b[23][1]++;
            cov_23jhm5whfq.s[91]++;
            position += 1;
            cov_23jhm5whfq.s[92]++;
            hover.parentNode.insertBefore(placeElement, hover.nextElementSibling);
          }
        } else {
          cov_23jhm5whfq.b[22][1]++;
        }
      } else {
        cov_23jhm5whfq.b[21][1]++;
        cov_23jhm5whfq.s[93]++;
        position += 1;
        cov_23jhm5whfq.s[94]++;
        hover.parentNode.insertBefore(placeElement, hover.nextElementSibling);
      }

      cov_23jhm5whfq.s[95]++;
      placeInfo.target = this.props.id; // @ts-ignore

      cov_23jhm5whfq.s[96]++;
      placeElement.setAttribute('data-position', position);
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd() {
      cov_23jhm5whfq.f[11]++;
      cov_23jhm5whfq.s[97]++;
      this.element.style.display = '';
      cov_23jhm5whfq.s[98]++;

      if (!isDragging) {
        cov_23jhm5whfq.b[24][0]++;
        cov_23jhm5whfq.s[99]++;
        return;
      } else {
        cov_23jhm5whfq.b[24][1]++;
      }

      cov_23jhm5whfq.s[100]++;
      isDragging = false;
      cov_23jhm5whfq.s[101]++;

      if (!placeElement.parentNode) {
        cov_23jhm5whfq.b[25][0]++;
        cov_23jhm5whfq.s[102]++;
        return;
      } else {
        cov_23jhm5whfq.b[25][1]++;
      }

      cov_23jhm5whfq.s[103]++;

      if ((cov_23jhm5whfq.b[27][0]++, this.dragImage) && (cov_23jhm5whfq.b[27][1]++, this.dragImage.parentNode)) {
        cov_23jhm5whfq.b[26][0]++;
        cov_23jhm5whfq.s[104]++;
        this.dragImage.parentNode.removeChild(this.dragImage);
      } else {
        cov_23jhm5whfq.b[26][1]++;
      }

      var _ref7 = (cov_23jhm5whfq.s[105]++, this.props),
          id = _ref7.id,
          index = _ref7.index,
          onDrop = _ref7.onDrop;

      var position = (cov_23jhm5whfq.s[106]++, parseInt((cov_23jhm5whfq.b[28][0]++, placeElement.getAttribute('data-position')) || (cov_23jhm5whfq.b[28][1]++, ''), 10));

      var _ref8 = (cov_23jhm5whfq.s[107]++, placeInfo),
          target = _ref8.target;

      cov_23jhm5whfq.s[108]++;
      placeElement.parentNode.removeChild(placeElement);
      cov_23jhm5whfq.s[109]++;

      if ((cov_23jhm5whfq.b[30][0]++, onDrop) && ((cov_23jhm5whfq.b[30][1]++, target !== id) || (cov_23jhm5whfq.b[30][2]++, index !== position))) {
        cov_23jhm5whfq.b[29][0]++;
        cov_23jhm5whfq.s[110]++;
        onDrop(id, target, position);
      } else {
        cov_23jhm5whfq.b[29][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_23jhm5whfq.f[12]++;

      var _ref9 = (cov_23jhm5whfq.s[111]++, this.props),
          data = _ref9.data,
          listComponent = _ref9.listComponent,
          onDrop = _ref9.onDrop,
          childrenClass = _ref9.childrenClass,
          leafClass = _ref9.leafClass,
          nodeClass = _ref9.nodeClass,
          other = _objectWithoutProperties(_ref9, ["data", "listComponent", "onDrop", "childrenClass", "leafClass", "nodeClass"]);

      var children = (cov_23jhm5whfq.s[112]++, data[other.childrenKey]);
      var hasChildren = (cov_23jhm5whfq.s[113]++, (cov_23jhm5whfq.b[31][0]++, children) && (cov_23jhm5whfq.b[31][1]++, children.length > 0));

      var _ref10 = (cov_23jhm5whfq.s[114]++, this.state),
          expanded = _ref10.expanded,
          fetching = _ref10.fetching;

      var listProps = (cov_23jhm5whfq.s[115]++, _objectSpread2(_objectSpread2({}, other), {}, {
        data: children,
        expanded: expanded,
        onDrop: onDrop,
        leafClass: leafClass,
        childrenClass: childrenClass,
        nodeClass: nodeClass,
        childrenClassName: childrenClass(data)
      }));
      var wrapProps = (cov_23jhm5whfq.s[116]++, {});
      cov_23jhm5whfq.s[117]++;

      if (onDrop) {
        cov_23jhm5whfq.b[32][0]++;
        cov_23jhm5whfq.s[118]++;
        Object.assign(wrapProps, {
          draggable: true,
          onDragStart: this.handleDragStart,
          onDragEnd: this.handleDragEnd
        });
      } else {
        cov_23jhm5whfq.b[32][1]++;
      } // node className


      var nodeClassName = (cov_23jhm5whfq.s[119]++, null);
      cov_23jhm5whfq.s[120]++;

      if (isString(nodeClass)) {
        cov_23jhm5whfq.b[33][0]++;
        cov_23jhm5whfq.s[121]++;
        nodeClassName = nodeClass;
      } else {
        cov_23jhm5whfq.b[33][1]++;
        cov_23jhm5whfq.s[122]++;

        if (isFunc(nodeClass)) {
          cov_23jhm5whfq.b[34][0]++;
          cov_23jhm5whfq.s[123]++;
          nodeClassName = nodeClass(data);
        } else {
          cov_23jhm5whfq.b[34][1]++;
        }
      }

      cov_23jhm5whfq.s[124]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, wrapProps, {
          ref: this.bindElement,
          className: classnames(treeClass(getDirectionClass('node')), (cov_23jhm5whfq.b[35][0]++, this.isLeaf()) && (cov_23jhm5whfq.b[35][1]++, leafClass(data)), nodeClassName),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 222,
            columnNumber: 7
          }
        }),
        /*#__PURE__*/
        React.createElement(Content, Object.assign({}, other, {
          active: this.state.active,
          data: data,
          expanded: expanded,
          onToggle: this.handleToggle,
          onDragOver: this.handleDragOver,
          setFetching: this.setFetching,
          fetching: fetching,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 227,
            columnNumber: 9
          }
        })), (cov_23jhm5whfq.b[36][0]++, hasChildren) && (cov_23jhm5whfq.b[36][1]++,
        /*#__PURE__*/
        createElement(listComponent, listProps)))
      );
    }
  }]);

  return Node;
}(PureComponent);

export default Node;